export class ActiveMembershipModel {
    public id: number = -1;
    public userId: number = -1;    
    public firstName: string = "";
    public lastName: string = "";
    public membershipId: string = "";
    public chapterId: number = 0 ;
    public chapterName: string="" ;
    public membershipFees: any ;
    public membershipExpiryDate : any ;
    public membershipSince : any ;
    public membershipStatus : any ;

}